import { ApiModule } from "@/api/api-module"
import routes from './routes'

export class ApiWorksheet extends ApiModule {
  
  /**
   * Получение доступов поста
   * @param {String} id
   */
  getAnketa(id) {
    return new Promise((resolve, reject) => {
      this.http.get(routes.anketa.replace('$id', id)).then(response => {
        if (response.status === 200 && response.data) {
          resolve(response.data)
        } else {
          reject("Error")
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
  
  /**
   * Поиск пользователя для назначения приватной роли
   * @param search
   * @returns {Promise<any>}
   */
  findUser(search){
    return new Promise((resolve, reject) => {
      this.http.post(routes.findUser, {search: search}).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  getTemplate(){
    return new Promise((resolve, reject) => {
      this.http.get(routes.template).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  updateTemplate(data){
    return new Promise((resolve, reject) => {
      this.http.patch(routes.template, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  view(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.form}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  update(id, data){
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.form}/${id}`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  getArchive(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.archive}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  getActive(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.active}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  forms(){
    return new Promise((resolve, reject) => {
      this.http.get(routes.forms).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  orgschemeForms(data){
    return new Promise((resolve, reject) => {
      this.http.post(routes.orgschemeForms, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  getStatusFolders(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.statusFolders}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  getStatusFolder(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.statusFolder}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  createStatusFolder(data){
    return new Promise((resolve, reject) => {
      this.http.put(routes.statusFolder, data).then(
        response => {
          resolve(response.data.id);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  updateStatusFolder(id, data){
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.statusFolder}/${id}`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  deleteStatusFolder(id){
    return new Promise((resolve, reject) => {
      this.http.delete(`${routes.statusFolder}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  getStatusTree(){
    return new Promise((resolve, reject) => {
      this.http.get(routes.statuses).then(
        response => {
          resolve(response.data.tree);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  getStatus(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.status}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  createStatus(data){
    return new Promise((resolve, reject) => {
      this.http.put(routes.status, data).then(
        response => {
          resolve(response.data.id);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  updateStatus(id, data){
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.status}/${id}`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  deleteStatus(id){
    return new Promise((resolve, reject) => {
      this.http.delete(`${routes.status}/${id}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  getFormStatuses(data){
    return new Promise((resolve, reject) => {
      this.http.post(routes.formStatuses, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  attachStatuses(data){
    return new Promise((resolve, reject) => {
      this.http.post(routes.addStatuses, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
}

let apiWorksheet = new ApiWorksheet("anketa")
export default apiWorksheet



// WEBPACK FOOTER //
// ./src/apps/org/api/anketa/index.js